const DATE_FORMATS = {
  MM_DD_YYYY: 1,
  DD_MM_YYYY: 2,
  YYYY_MM_DD: 3,
  MMM_DD_YYYY: 4
} as const

type DateFormatKeys = keyof typeof DATE_FORMATS
type DateFormatValues = (typeof DATE_FORMATS)[DateFormatKeys]

interface DateFormatItem {
  id: DateFormatValues
  value: DateFormatValues
  label: string
  format: string
  placeholder: string
}

const DATE_FORMATS_OBJ: Record<DateFormatValues, DateFormatItem> = {
  [DATE_FORMATS.MM_DD_YYYY]: {
    id: 1,
    value: 1,
    label: "MM/DD/YYYY",
    format: "MM/DD/YYYY",
    placeholder: "01/31/2026"
  },
  [DATE_FORMATS.DD_MM_YYYY]: {
    id: 2,
    value: 2,
    label: "DD/MM/YYYY",
    format: "DD/MM/YYYY",
    placeholder: "31/01/2026"
  },
  [DATE_FORMATS.YYYY_MM_DD]: {
    id: 3,
    value: 3,
    label: "YYYY-MM-DD",
    format: "YYYY-MM-DD",
    placeholder: "2026-01-31"
  },
  [DATE_FORMATS.MMM_DD_YYYY]: {
    id: 4,
    value: 4,
    label: "MMM DD, YYYY",
    format: "MMM DD, YYYY",
    placeholder: "Jan 31, 2026"
  }
}

const DATE_FORMATS_LIST = Object.values(DATE_FORMATS_OBJ)
const ALL_DATE_FORMATS = [
  ...DATE_FORMATS_LIST.map((f) => `${f.format} HH:mm`),
  ...DATE_FORMATS_LIST.map((f) => `${f.format} h:mm A`),
  "MMMM D, YYYY HH:mm",
  "MMMM DD, YYYY HH:mm",
  "MMMM D, YYYY h:mm A",
  "MMMM DD, YYYY h:mm A",
  ...DATE_FORMATS_LIST.map((f) => f.format),
  "MMMM D, YYYY",
  "MMMM DD, YYYY"
]

export {
  DATE_FORMATS,
  DATE_FORMATS_OBJ,
  DATE_FORMATS_LIST,
  ALL_DATE_FORMATS,
  type DateFormatValues,
  type DateFormatItem
}
